export default __webpack_public_path__ + "static/media/er.0c35ccff.svg";